import { styled } from '@mui/material';

const StyledMainContentInnerHtml = styled('main')(({ theme }) => ({
	'& p': {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: '25.6px',
		letterSpacing: '0.15px',

		'&:has(em), &:has(img)': {
			margin: '24px 0 !important',

			[theme.breakpoints.down('sm')]: {
				margin: '16px 0 !important',
			},
		},

		[theme.breakpoints.down('sm')]: {
			lineHeight: '26px',

			'&:has(strong), &:has(h4)': {
				lineHeight: '22.4px',
			},
		},

		'&:not(:last-child)': {
			margin: '0px 0px 16px 0px',
		},
	},
	'& em': {
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0px',

		[theme.breakpoints.down('sm')]: {
			margin: 0,
		},
	},
	'& h1': {
		fontSize: '32px',
		fontWeight: 700,
		lineHeight: '40px',
		margin: '0px 0px 24px 0px',

		[theme.breakpoints.down('sm')]: {
			fontSize: '28px',
			lineHeight: '36px',
		},
	},
	'& h2': {
		fontSize: '24px',
		fontWeight: 600,
		lineHeight: '32px',
		margin: '0px 0px 16px 0px',
	},
	'& h3': {
		fontSize: '20px',
		fontWeight: 600,
		lineHeight: '28px',
		margin: '0px 0px 16px 0px',

		[theme.breakpoints.down('sm')]: {
			fontSize: '18px',
			lineHeight: '26px',
		},
	},
	'& h4, & strong': {
		fontSize: '18px',
		fontWeight: 600,
		lineHeight: '28.8px',
		letterSpacing: '0.15px',
		margin: '0px 0px 16px 0px',

		[theme.breakpoints.down('sm')]: {
			lineHeight: '22.4px',
			fontSize: '16px',
			letterSpacing: '0.3px',
		},
	},
	'& h5': {
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '24px',
		margin: '0px 0px 16px 0px',

		[theme.breakpoints.down('sm')]: {
			fontSize: '14px',
			lineHeight: '22px',
		},
	},
	'& h6': {
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '20px',
		margin: '0px 0px 16px 0px',

		[theme.breakpoints.down('sm')]: {
			fontSize: '12px',
			lineHeight: '18px',
		},
	},
	'& img': {
		maxWidth: '100%',
		width: '100%',
		height: 'auto',
		display: 'block',
		objectFit: 'contain',
		[theme.breakpoints.up('sm')]: {
			borderRadius: '10px',
		},
	},
	'& iframe': {
		marginBottom: '24px !important',
		maxWidth: '100%',
		marginTop: '0px !important',

		[theme.breakpoints.up('sm')]: {
			marginTop: '8px !important',
			borderRadius: '10px',
		},
	},
}));

export default StyledMainContentInnerHtml;
